<template>
  <TheUncle :color="true" title="완료된 사입" description="처리가 완료된 사입 목록입니다.">
    <a-card v-if="account">
      <b>사용자 이름:</b>
      {{ account.username }}
      <br />
      <b>사용자 아이디:</b>
      {{ account.identity }}
      <br />
      <b>사용자 고유넘버:</b>
      {{ account.idx }}
      <br />
      <b>총 거래 금액</b>
      {{ (amount || 0).toLocaleString() }}원
    </a-card>
    <a-collapse accordion style="margin-top: 0.5em;">
      <a-collapse-panel
        v-for="saib in saibs"
        :key="saib.idx"
        :class="`admin-color-${saib.status}`"
        :header="`
          [${saib.status === 0 ? '접수' 
          : saib.status === 1 ? '처리 중' 
          : saib.status === 2 ? '성공' 
          : saib.status === 3 ? '실패' : '대기' }]
          ${ saib.type === 0 ? '사입': '교환 / 반납' } - ${saib.account.username}:
          ${saib.wholesale.location.building}
          ${saib.wholesale.location.mall} 
          ${saib.wholesale.location.floor}층 
          ${saib.wholesale.location.row}열 
          ${saib.wholesale.location.place}호 - ${saib.wholesale.name}
        (${$moment(saib.processAt).format('LT')})`"
      >
        <dl>
          <dt>방식:</dt>
          <dd v-if="saib.type === 0" class="cl-green">사입</dd>
          <dd v-else-if="saib.type === 1" class="cl-red">교환 / 반납</dd>
          <dd v-else class="cl-yellow">알 수 없음</dd>
          <dt>처리 상태:</dt>
          <dd v-if="saib.status === 0">
            <a-badge status="default" />
            <b>접수</b>
          </dd>
          <dd v-if="saib.status === 1">
            <a-badge status="processing" />
            <b>처리 중</b>
          </dd>
          <dd v-if="saib.status === 2">
            <a-badge status="success" />
            <b>성공</b>
          </dd>
          <dd v-if="saib.status === 3">
            <a-badge status="error" />
            <b>실패</b>
          </dd>
          <dd v-if="saib.status === 4 && saib.type === 0">
            <a-badge status="warning" />
            <b>대기</b>
          </dd>
          <dd v-if="saib.status === 4 && saib.type === 1">
            <a-badge status="warning" />
            <b>맡김</b>
          </dd>
          <dt>품목</dt>
          <dd>
            <SaibItemDetail :items="saib.details" />
          </dd>
          <dt v-if="saib.type === 0">금액</dt>
          <dd v-if="saib.type === 0">{{ (saib.price || 0).toLocaleString() }}원</dd>
          <dt v-if="saib.type === 1">요청 사유:</dt>
          <dd v-if="saib.type === 1">{{ saib.contents }}</dd>
          <dt v-if="$route.params.idx === 'all'">사용자 정보:</dt>
          <dd v-if="$route.params.idx === 'all'">
            <a-card>
              <b>사용자 이름:</b>
              {{ saib.account.username }}
              <br />
              <b>사용자 아이디:</b>
              {{ saib.account.identity }}
              <br />
              <b>사용자 고유넘버:</b>
              {{ saib.account.idx }}
            </a-card>
          </dd>
          <dt>도매 정보:</dt>
          <dd>
            <a-card>
              <b>도매 이름:</b>
              {{ saib.wholesale.name}}
              <br />
              <b>전화번호:</b>
              <a
                class="ant-btn"
                :href="`tel://${saib.wholesale.phone}`"
                style="color: #000;"
              >{{ saib.wholesale.phone }}</a>
              <br />
              <b>휴대폰 번호:</b>
              <a
                class="ant-btn"
                :href="`tel://${saib.wholesale.mobile}`"
                style="color: #000;"
              >{{ saib.wholesale.mobile }}</a>
              <br />
              <b>위치:</b>
              {{ saib.wholesale.location.building +
              ' (' + saib.wholesale.location.mall + ') ' +
              saib.wholesale.location.floor + '층 ' +
              saib.wholesale.location.row + '열 ' +
              saib.wholesale.location.place + '호' }}
            </a-card>
          </dd>
          <dt>담당자:</dt>
          <dd>{{ `${saib.manager.username}(${saib.manager.identity})` }}</dd>
          <dd></dd>
          <dt>요청 시간:</dt>
          <dd>{{ $moment(saib.uploadAt).format('llll') }}</dd>
          <dt>처리 시간:</dt>
          <dd>{{ $moment(saib.processAt).format('llll') }}</dd>
        </dl>
        <CompletedEdit v-if="editing === saib.idx" :saib="saib" :onClose="onClose" />
        <a-button
          v-if="saib.manager.idx === $store.state.uncle.idx"
          style="margin: 5px;"
          type="primary"
          icon="edit"
          class="fl-right"
          @click="onEditing(saib.idx)"
        >수정</a-button>
      </a-collapse-panel>
    </a-collapse>
  </TheUncle>
</template>
<script>
import TheUncle from "../../../components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../../config";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";
import SaibItemDetail from "../../../components/Saib/SaibItemDetail";
import CompletedEdit from "./CompletedEdit";

export default {
  name: "UncleSaibCompletedProperty",
  components: { TheUncle, SaibItemDetail, CompletedEdit },
  data() {
    this.onRefresh();
    return {
      editing: null,
      saibs: [],
      account: null,
      amount: 0
    };
  },
  methods: {
    async onEditing(idx) {
      this.editing = idx;
    },
    async onRefresh() {
      if (!this.$route.params.idx) {
        this.$router.push("/uncle/completed");
        config.alert.mixin({
          title: "오류가 발생했습니다.",
          type: "error"
        });
      }

      const { data } = await Axios.get(
        `${config.hostname}/v1/uncle/saib/completed/${this.$route.params.idx}`,
        {
          withCredentials: true
        }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.saibs = data.saibs;
            this.saibs.forEach(v => {
              if (v.status === 2) this.amount += v.price;
            });

            if (data.account) {
              this.account = data.account;
            }
            break;
          default:
            this.$router.push("/uncle/completed");
            config.alert.mixin({
              title: "알 수 없는 오류가 발생했습니다.",
              type: "error,"
            });
            break;
        }
      }
    },
    onClose() {
      this.onRefresh();
      this.editing = null;
    }
  }
};
</script>